import { ZodProvider } from "@autoform/zod";

import { LoadingButton } from "@/components/common/loading-button";
import { AutoForm } from "@/components/ui/autoform";
import { injectCustomAutoFormComponents } from "@/components/ui/autoform/components/custom";
import { EventTagsField } from "@/pages/events/components/fields/event-tags-field";
import { useEventCreateForm } from "@/pages/events/create/hooks/use-event-create-form";
import { mediaEventSchema } from "@/pages/events/schemas/event.create.form";

const schemaProvider = new ZodProvider(mediaEventSchema);

export const EventMediaStep = () => {
  const { id, mediaStep, onMediaStepSubmit, loading } = useEventCreateForm();

  return (
    <div className="flex flex-col gap-2">
      <AutoForm
        schema={schemaProvider}
        defaultValues={{ ...mediaStep, id }}
        onSubmit={(data, _) => {
          onMediaStepSubmit(data);
        }}
        withSubmit
        {...injectCustomAutoFormComponents({
          formComponents: {
            eventTags: EventTagsField,
          },
        })}
      >
        <div className="flex justify-end">
          <LoadingButton isLoading={loading.media === "loading"}>
            Create Event
          </LoadingButton>
        </div>
      </AutoForm>
    </div>
  );
};
